import React, { FC, PropsWithChildren, memo } from 'react';

import { useMediaQuery } from '@hooks/common/useMediaQuery';

import ModalBox from '@components/common/Modal/ModalWrapper/ModalBox';
import Popup from '@components/common/Modal/ModalWrapper/Popup';

interface Props extends PropsWithChildren {
  isHideCloseBtn?: boolean;
  title?: string;
  onClose?: () => void;
  className?: string;
  classNameMobPopup?: string;
}

const ModalWrapper: FC<Props> = ({
  children,
  isHideCloseBtn = false,
  title = '',
  onClose = undefined,
  className = '',
  classNameMobPopup = '',
  ...props
}) => {
  const { desktopView } = useMediaQuery();

  return (
    <>
      {desktopView ? (
        <ModalBox
          isHideCloseBtn={isHideCloseBtn}
          title={title}
          onClose={onClose}
          className={className}
          {...props}
        >
          {children}
        </ModalBox>
      ) : (
        <Popup
          title={title}
          onClose={onClose}
          classNameModal={classNameMobPopup}
          {...props}
        >
          {children}
        </Popup>
      )}
    </>
  );
};

export default memo(ModalWrapper);
